import isEqual from 'lodash/isEqual';
import { Stage, StageStatusEnum, Widget, WidgetData } from '../../models/Index';

function areUnsavedChangesPresent(current: Stage, saved: Stage): boolean {
  if (
    ((current?.draftId || current?.stageId) && saved?.stageId) ||
    (current?.status === StageStatusEnum.NEW && saved?.status === StageStatusEnum.NEW)
  ) {
    if (
      current.title !== saved.title ||
      current.workInProgressGridConfig?.layouts?.lg?.length !== saved.workInProgressGridConfig?.layouts?.lg?.length ||
      current.workInProgressWidgetData?.length !== saved.workInProgressWidgetData?.length ||
      arePositionsDifferent(current, saved) ||
      areWidgetConfigurationsDifferent(current, saved)
    ) {
      return true;
    }
  }
  return false;
}

function arePositionsDifferent(current: Stage, saved: Stage): boolean {
  const currentLayout = (current.workInProgressGridConfig?.layouts?.lg as Widget[]) || [];
  const savedLayout = (saved.workInProgressGridConfig?.layouts?.lg as Widget[]) || [];
  let isSame = false;
  const propertiesToTest = ['h', 'w', 'x', 'y'];
  if (currentLayout.length > 0) {
    currentLayout.forEach((item, index) => {
      propertiesToTest.forEach((key) => {
        if (item[key] !== savedLayout[index][key]) {
          isSame = true;
        }
      });
    });
  }

  return isSame;
}

function areWidgetConfigurationsDifferent(current: Stage, saved: Stage): boolean {
  const currentProperties = current.workInProgressWidgetData as WidgetData[];
  const savedProperties = saved.workInProgressWidgetData as WidgetData[];
  return !isEqual(currentProperties, savedProperties);
}

const UtilService = {
  areUnsavedChangesPresent,
};

export default UtilService;
